const SessionActionTypeEnum = {
  SAVE_OWNER_CONTENT_FAILURE: 'SESSION_CONTENT_UPDATE_OWNER_FAILURE',
  SAVE_OWNER_CONTENT_REQUEST: 'SESSION_CONTENT_UPDATE_OWNER_REQUEST',
  SAVE_OWNER_CONTENT_SUCCESS: 'SESSION_CONTENT_UPDATE_OWNER_SUCCESS',
  SAVE_SESSION_CONTENT_PASS: 'SESSION_CONTENT_UPDATE_CONTENT_REQUEST_PASSED',
  SAVE_SESSION_CONTENT_REQUEST: 'SESSION_CONTENT_UPDATE_REQUEST',
  SAVE_SHARED_CONTENT_FAILURE: 'SESSION_CONTENT_UPDATE_SHARED_FAILURE',
  SAVE_SHARED_CONTENT_REQUEST: 'SESSION_CONTENT_UPDATE_SHARED_REQUEST',
  SAVE_SHARED_CONTENT_SUCCESS: 'SESSION_CONTENT_UPDATE_SHARED_SUCCESS',

  SET_SESSION_AUTO_SAVE_VALUE: 'SESSION_CONTENT_AUTO_SAVE_VALUE_SET',
  SAVE_SESSION_REQUEST: 'SESSION_SAVE_REQUEST',
  SAVE_SESSION_SUCCESS: 'SESSION_SAVE_SUCCESS',
  SAVE_SESSION_FAILURE: 'SESSION_SAVE_FAILURE',

  START_AUTO_SAVE: 'START_AUTO_SAVE',
  STOP_AUTO_SAVE: 'STOP_AUTO_SAVE',
};

export default SessionActionTypeEnum;



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/SessionConstants.jsx